import isNil from 'ramda/src/isNil';

const AMAZON_SLUG = 'amazon-delivery-service-partner';
const DSP_SLUG = 'delivery-service-partner';

export function getCSRF() {
  const csrfTokenParamNode = document.querySelector('meta[name="csrf-param"]');
  const csrfTokenValueNode = document.querySelector('meta[name="csrf-token"]');

  if (csrfTokenParamNode && csrfTokenValueNode) {
    return {
      param: csrfTokenParamNode.content,
      token: csrfTokenValueNode.content,
    };
  }

  return null;
}

export function getPaginationSlice({ currentPage, perPage, totalCount }) {
  const min = ((currentPage - 1) * perPage) + 1;
  const max = Math.min((currentPage * perPage), totalCount);

  return `${min}-${max} of`;
}

export function isAmazon(accountSlug) {
  return [AMAZON_SLUG, DSP_SLUG].includes(accountSlug);
}

export function getCustomPropertiesFromObject(object) {
  const filteredProperties = Object.keys(object).filter(key => !isNil(object[key]));
  const properties = filteredProperties.map(key => `${key}: ${object[key]};`);

  return `
    :root {
      ${properties.join('\r\n')}
    }
  `;
}

export function getUrlParamsString() {
  return document.location.href.split('?')[1] || '';
}

export const STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const getJobType = (jobType) => {
  switch (jobType) {
    case 'permanent':
      return 'Permanent';
    case 'contract_freelancer':
      return 'Contract';
    case 'temporary':
      return 'Temporary';
    case 'casual':
      return 'Casual';
    case 'finance_plus_accounting':
      return 'Finance + Accounting';
    case 'operations_leadership':
      return 'Operations Leadership';
    case 'all_other_administrative_plus_professional':
      return 'All Other Administrative + Professional';
    case 'information_technology':
      return 'Information Technology';
    case 'customer_service_plus_operations':
      return 'Customer Service + Operations';
    default:
      return null;
  }
};
